import React, { lazy } from 'react'
// Libraries
import { Col, Container, Navbar, Row, Button, Tab, Tabs } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { AnimatePresence, m } from 'framer-motion'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Parallax } from "react-scroll-parallax";
import { Helmet } from "react-helmet";
import { Link as ScrollTo } from "react-scroll"
import { SwiperSlide, Swiper } from 'swiper/react';
import { Keyboard } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import PricingTable from "../Components/PricingTable";

// Components
import { fadeIn, fadeInLeft, zoomIn } from '../Functions/GlobalAnimations'
import HeaderForBus from "../Pages/Header/HeaderForBus";
import FooterStyle from '../Pages/Footer/Footer';
import MainHeader from "../Pages/Header/MainHeader";
import { useNavigate } from "react-router-dom";
import InteractiveBanners02 from '../Components/InteractiveBanners';
import InteractiveBanners01 from '../Components/InteractiveBanners01'
import CustomIconWithText from '../Components/CustomIconWithText'
import Buttons from '../Components/Button/Buttons'
import ContactForm from '../Pages/ComponentPage/ContactForm';
import { IMAGE_PATHS } from '../Functions/Constant';
import ButtonsVariant from '../Components/Button/ButtonVariant'; // Fixed: Use default import
// import TestimonialsCarousel07 from '../Components/TestimonialCarousel/TestimonialsCarousel07';
// import { TestimonialsData03 } from '../Components/TestimonialCarousel/TestimonialsCarouselData';
import Clients from '../Components/Clients';
import Testimonials from '../Components/Testimonials/Testimonials';
import LetGo from "../Pages/ComponentPage/LetGo";




const TestimonialsData03 = [
    {
        name: "Manpreet Kaur",
        designation: "Founder & CEO",
        content:
            "I’ve used JobCritics to verify candidates and received detailed reviews and ratings from their previous employers. This insight helped me better understand each candidate, making my hiring decisions more informed and confident.",
        img: "https://jobcritics.com/assets/img/biar/manpreet.webp",
    },
    {
        name: "Shanker Singh",
        designation: "Director",
        content:
            "I was about to hire a candidate but, fortunately, checked JobCritics. I discovered they hadn’t properly served their notice at their previous job, causing losses. The platform allowed me to make a more ethical hiring decision.",
        img: "https://jobcritics.com/assets/img/biar/shanker.webp",
    },
    {
        name: "Jagjeet Singh",
        designation: "Director",
        content:
            "An employee left after just three days and sent a legal notice demanding their salary. While I released the salary, I also updated my feedback on JobCritics. I believe this will help maintain an ethical and transparent work culture.",
        img: "https://jobcritics.com/assets/img/biar/jagjeet.webp",
    },
];


const ProcessStep = lazy(() => import('../Components/ProcessStep/ProcessStep'))


const InteractiveBannersData02 = [
    {
        subtitle: "See Real Professional History",
        title: "Get access to verified ratings and reviews from past employers, peers, and clients—no guesswork.",
        img: "https://jobcritics.com/assets/img/biar/4(1).webp",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"

    },
    {
        subtitle: "Instant Profile Verification",
        title: "Verify candidates’ job history, skills, and behavior in just one click, saving time and reducing errors.",
        img: "https://jobcritics.com/assets/img/biar/5(1).webp",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"

    },
    {
        subtitle: "Reduce Hiring Fraud",
        title: "Avoid early exits, fake profiles, and resume padding with transparent, data-backed hiring insights.",
        img: "https://jobcritics.com/assets/img/biar/2(2).webp",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"

    },
    {
        subtitle: "Hire Better, Faster",
        title: "Make confident hiring decisions with AI-powered credibility reports and smart connection tools.",
        img: "https://jobcritics.com/assets/img/biar/3(1).webp ",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"

    }
]
const InteractiveBannersData01 = [
    {
        subtitle: "Instant Ratings",
        title: "View real, peer-verified reviews of every candidate.",
        img: "https://jobcritics.com/assets/img/biar/same_image1.webp",

    },
    {
        subtitle: "Smart Profiles",
        title: "Access AI-generated career summaries for faster hiring.",
        img: "https://jobcritics.com/assets/img/biar/same_image2.webp",

    },
    {
        subtitle: "Verified Hiring",
        title: "Check credentials, job history, and performance in one click.",
        img: "https://jobcritics.com/assets/img/biar/same_image3.webp",

    },
    {
        subtitle: "Report Defaulters",
        title: "Flag no-shows or fraud cases to protect other businesses.",
        img: "https://jobcritics.com/assets/img/biar/same_image4.webp",
    }
]
const ProcessStepData = [
    {
        title: "Search Verified Profiles",
        content: "Browse professional profiles backed by peer ratings and work history.",
    },
    {
        title: "One-Click Credential Checks",
        content: "Instantly verify skills, experience, and tenure—no follow-ups needed.",
    },
    {
        title: "Review Career Reports",
        content: "Access AI-generated summaries for clear, data-backed hiring decisions.",
    }
    ,
    {
        title: "Make Confident Hires",
        content: "Avoid fraud, reduce hiring time, and build stronger teams with trusted data.",
    }
]
const CustomIconWithTextData2 = [

    {
        icon: "line-icon-Navigation-LeftWindow yellow-class",
        title: "One-Click Verification",
        content: "Instantly check a candidate’s credibility with AI-backed reports and real ratings."
    },
    {
        icon: "line-icon-Cursor-Click2 yellow-class",
        title: "Shared Review Network",
        content: "Connect with other businesses to exchange verified reviews and reduce duplication."
    },
    {
        icon: "line-icon-Like-2 yellow-class",
        title: "AI-Powered Hiring Insights",
        content: "Use intelligent scoring to rank candidates and make faster, smarter decisions."
    },
    {
        icon: "line-icon-Talk-Man yellow-class",
        title: "Custom Integrations",
        content: "Use powerful APIs to plug JobCritics into your existing HR or ATS systems."
    },
    {
        icon: "line-icon-Paper-Plane yellow-class",
        title: "Flag & Prevent Fraud",
        content: "Report non-joiners or unreliable candidates and protect the larger ecosystem."
    },
    {
        icon: "line-icon-Heart yellow-class",
        title: "Improve Employer Branding",
        content: "Be a part of a trusted network that values transparency and professional accountability."
    }

]


const pricingTable03YearData = [

    {
        icon: "line-icon-Business-ManWoman",
        title: "Basic",
        subtitle: "",
        price: "",
        // term: "monthly",
        plans: [
            `<strong>Join for Free</strong>`,
            `<strong> Create and Manage Your Professional Business Profile with Ease</strong>`,
            `<strong> Post Unlimited Job Listings Anytime</strong>`,
            `<strong> Verify Candidates at Just $1 Per Profile Whenever Needed</strong> `,
            `<strong> Help Center Resources Instantly</strong> `,
            `<strong> Enjoy all Essential Features</strong> `
        ],
        buttonTitle: "Buy Now",
        buttonLink: "/contact_us",
        // popular: {
        //     isPopular: true
        // }
    },
    {
        icon: "line-icon-Business-Mens",
        title: "Standard",
        subtitle: "",
        price: "",
        // term: "monthly",
        plans: [
            `<strong>$1000/year</strong>`,
            `<strong>Verify up to 2,000 Profiles per Year</strong>`,
            `<strong>1,000 Credits to Connect with Companies for Instant Back Checks</strong>`,
            `<strong>All Freemium Features Included</strong>  `
        ],
        buttonTitle: "Buy Now",
        buttonLink: "/contact_us",
        popular: {
            isPopular: true
        }
    },
    {
        icon: "line-icon-Boy",
        title: "Advanced",
        subtitle: "",
        price: "",
        // term: "monthly",
        plans: [
            `<strong> $5,000/year </strong>`,
            ` <strong>Verify up to 15,000 Profiles per Year</strong>`,
            `<strong>$1,000 in Advertising Credits</strong>`,
            `<strong>5,000 Credits to Connect with Companies for Instant Back Checks</strong>`,
            `<strong>Instant Customer Support Access</strong>`,
            `<strong>All Freemium Features Included</strong>`
        ],
        buttonTitle: "Buy Now",
        buttonLink: "/contact_us",

    },
]
const pricingTable03MonthData = [

    {
        icon: "line-icon-Business-ManWoman",
        title: "Basic",
        subtitle: "",
        price: "",
        // term: "monthly",
        plans: [
            `<strong>Join for Free</strong>`,
            `<strong> Create and Manage Your Professional Business Profile with Ease</strong>`,
            `<strong> Post Unlimited Job Listings Anytime</strong>`,
            `<strong> Verify Candidates at Just $1 Per Profile Whenever Needed</strong> `,
            `<strong> Help Center Resources Instantly</strong> `,
            `<strong> Enjoy all Essential Features</strong> `
        ],
        buttonTitle: "Buy Now",
        buttonLink: "/contact_us",
        // popular: {
        //     isPopular: true
        // }
    },
    {
        icon: "line-icon-Business-Mens",
        title: "Standard",
        subtitle: "",
        price: "",
        // term: "monthly",
        plans: [
            `<strong>$100/month</strong>`,
            `<strong>Verify up to 2,000 Profiles per month</strong>`,
            `<strong>1,000 Credits to Connect with Companies for Instant Back Checks</strong>`,
            `<strong>All Freemium Features Included</strong>  `
        ],
        buttonTitle: "Buy Now",
        buttonLink: "/contact_us",
        popular: {
            isPopular: true
        }
    },
    {
        icon: "line-icon-Boy",
        title: "Advanced",
        subtitle: "",
        price: "",
        // term: "monthly",
        plans: [
            `<strong>$500/month</strong>`,
            ` <strong>Verify up to 15,000 Profiles per month</strong>`,
            `<strong>$1,000 in Advertising Credits</strong>`,
            `<strong>5,000 Credits to Connect with Companies for Instant Back Checks</strong>`,
            `<strong>Instant Customer Support Access</strong>`,
            `<strong>All Freemium Features Included</strong>`
        ],
        buttonTitle: "Buy Now",
        buttonLink: "/contact_uss",

    },
]
const ClientData = [
    {
        img: 'https://jobcritics.com/assets/img/biar/eltac_logo.webp?v1',

    },
    {
        img: 'https://jobcritics.com/assets/img/biar/FM_New_logo.webp',

    },
    {
        img: 'https://jobcritics.com/assets/img/biar/Digiaeon.webp',

    },
    {
        img: 'https://jobcritics.com/assets/img/biar/salonation.webp',

    }
]
const Businesses = (props) => {


    const navigate = useNavigate();
    const jobcritic_usertype = localStorage.getItem("jobcritic_usertype");
    const handleReviewClick = () => {
        const jwtTokenJobcritic = localStorage.getItem("jwt_token_jobcritic"); // Check user_id in localStorage
        if (jwtTokenJobcritic) {
            if (jobcritic_usertype == 2) {
                navigate("/verifications");
            } else {
                navigate("/profile"); // If logged in, go to review form
            }
        } else {
            navigate("/business-login");  // If logged in, go to review form

        }
    };
    return (
        <div style={props.style}>
            {/* <SideButtons /> */}
            {/* Header Start */}
            {jobcritic_usertype == 2 ? <HeaderForBus /> : <MainHeader />}
            {/* Header End */}
            <Helmet>
                <meta property="og:title" content="JobCritics – Verify Candidates, Recognize Talent, Report Misconduct" />
                <meta property="og:description" content="An all-in-one platform to verify professional history, endorse top talent, and flag unethical behavior. Streamline your hiring and employee management." />
                <meta property="og:image" content="https://jobcritics.com/assets/img/biar/business_og.webp" />
                <meta property="og:url" content="https://jobcritics.com/organizations" />
                <meta property="og:type" content="website" />

                <meta name="twitter:title" content="JobCritics – Verify Candidates, Recognize Talent, Report Misconduct" />
                <meta name="twitter:description" content="An all-in-one platform to verify professional history, endorse top talent, and flag unethical behavior. Simplify hiring and employee management with JobCritics." />
                <meta name="twitter:image" content="https://jobcritics.com/assets/img/biar/business_og.webp" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://jobcritics.com/organizations" />

                {/* <meta
                    name="description"
                    content="Start hiring smarter with JobCritics. Instantly verify candidate credentials through trusted ratings, reviews, and AI-powered career insights."
                /> */}
            </Helmet>
            <section className="py-[130px] overflow-hidden lg:py-[90px] sm:py-[75px] xs:py-[50px] !pt-[200px] xs:!pt-[75px] md:!pt-[75px]">
                <Container>
                    <Row className="items-center justify-center">
                        <Col lg={6} md={9} className="mb-[10px] md:mb-28 xs:text-center">
                            {/* <h2 className="heading-5 font-serif font-semibold  uppercase mb-[9px] black-class text-[22px]">Start Hiring Smarter Today!</h2> */}
                            <h3 className="font-serif font-bold   mb-[35px] tracking-[-1px] text-black text-[56px] leading-[1.1]">Verify Candidates.<br />Recognize Talent.<br /> Report Misconduct.</h3>
                            <p className="w-[90%] xs:w-[100%] text-lg mb-[35px] leading-[38px] xs:text-xmd black-class !text-[32px] xs:leading-[1.2]">All-in-one platform to verify professional history, endorse great employees, and flag unethical behaviour.</p>

                            <ButtonsVariant
                                href="#"
                                ariaLabel="button"
                                onClick={handleReviewClick}
                                className="mx-[10px]"
                                variant="blackToWhite"
                                size="xl"
                                title="Start Verifying Now"
                            />
                        </Col>
                        <Col lg={6} md={9} xs={12} className="px-[55px] md:pr-[50px] md:pl-[5px]">
                            <m.figure className="image-back-offset-shadow w-100">
                                <m.img
                                    className="rounded-[6px] w-auto h-auto"
                                    src={IMAGE_PATHS.ourservices01}
                                    alt="Verify Candidates.Recognize Talent.Report Misconduct."
                                    width="572.5"
                                    height="436.53"
                                    initial={{ opacity: 0, x: "0", y: "0" }}
                                    whileInView={{ opacity: 1, x: "10px", y: "-20px" }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.4, easing: "linear" }}
                                />
                                <m.span
                                    className="rounded-[6px]"
                                    {...{ ...fadeIn, animate: { x: "35px", y: "5px" } }}
                                ></m.span>
                            </m.figure>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="py-[130px] lg:py-[90px] md:py-[75px] sm:[50px] bj overflow-hidden">
                <Container>
                    <Row className="justify-center">
                        <m.div className="col-xl-10 col-lg-10 col-md-10 col-sm-10 mb-20 text-center md:mb-[60px] sm:[44px]" {...fadeIn}>
                            {/* <span className="mb-[20px] font-medium text-md font-serif uppercase inline-block text-gradient yellow-class">Why choose us?</span> */}
                            <h4 className="font-semibold -tracking-[1px] text-darkgray font-serif block heading-5">The World’s Only Platform for Individual Ratings and Reviews</h4>
                        </m.div>
                    </Row>
                </Container>
                <Container>
                    <InteractiveBanners02
                        carousalOption={{
                            slidesPerView: 1,
                            spaceBetween: 30,
                            loop: true,
                            autoplay: { delay: 2500, disableOnInteraction: false },
                            breakpoints: { 1200: { slidesPerView: 3 }, 992: { slidesPerView: 2 }, 768: { slidesPerView: 2 } }
                        }}
                        data={InteractiveBannersData02}
                        animation={fadeIn}
                        animationDelay={0}
                    />
                </Container>
            </section>

            <Helmet>
                <meta
                    name="description"
                    content="JobCritics gives businesses access to verified, peer-reviewed profiles—making hiring faster, smarter, and more reliable"
                />
            </Helmet>

            <section className="py-[160px] overflow-hidden relative lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]">
                <Container>
                    <Row className="items-center justify-center">
                        <Col xl={6} md={6} xs={11} className="sm:mb-[30px]">
                            <m.h2  {...{ ...fadeIn, transition: { delay: 0.2 } }} className="heading-4 font-serif font-semibold text-darkgray mb-0 text-center">A Smarter Way to Evaluate and Hire Talent</m.h2>
                            {/* <span className="font-serif font-semibold   tracking-[1px] inline-block  mb-[20px] sm:mb-[10px]">A Smarter Way to Evaluate and Hire Talent</span> */}
                        </Col>
                        <Col xl={{ span: 5, offset: 1 }} md={6} xs={11}>
                            <m.p  {...{ ...fadeIn, transition: { delay: 0.3 } }} className="text-lg mb-[25px] leading-[38px] md:text-xmd xs:text-center">JobCritics is a verification and reputation platform that gives employers real-time access to authentic, peer-reviewed profiles. Replace blind hiring with data-backed insights that help you choose the right people—faster and with more confidence</m.p>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="overflow-hidden relative">
                <InteractiveBanners01 grid="row-cols-1" data={InteractiveBannersData01} animation={fadeIn} />
            </section>

            <Helmet>
                <meta
                    name="description"
                    content="See how JobCritics helps businesses hire better with verified profiles, instant checks, AI career reports, and fraud-free decisions."
                />
            </Helmet>
            <section className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] overflow-hidden startup-processstep bj">
                <Container>
                    <Row className="items-center justify-center">
                        <Col xl={5} lg={6} md={10}>
                            {/* <span className="font-serif text-xmd font-medium text-basecolor inline-block mb-[20px] sm:mb-[10px]">How JobCritics Works for Businesses</span> */}
                            <h2 className="heading-5 font-serif font-semibold text-darkgray block -tracking-[.5px] mb-20 w-[98%] lg:mb-[80px] md:mb-12 md:w-[98%] sm:w-full">Hire Smarter in Just a Few Clicks</h2>
                            <ProcessStep grid="row-cols-1" theme='process-step-style-02' data={ProcessStepData} animation={fadeIn} />
                        </Col>
                        <m.div className="offset-xl-1 col-lg-6 md:mt-[50px]" {...fadeInLeft}>
                            <div className="-mr-[30vw] relative md:mr-0" >
                                <img src={IMAGE_PATHS.homestartupbusinessprocess} width={1109} height={638} className="overflow-hidden" alt="Hire Smarter in Just a Few Clicks" />
                            </div>
                        </m.div>
                    </Row>
                </Container>
            </section>
            <section className="text-center relative grid-rows-3 grid-cols-2 py-[130px] opacity-[1] overflow-hidden  lg:py-[90px] sm:py-[75px] xs:py-[50px]" >
                <Container>
                    <Col className="relative mb-12 lg:mb-[40px] sm:mb-[7.5rem] xs:mb-[4.5rem]">
                        <h5 className="font-serif font-semibold text-darkgray">What Makes JobCritics Unique for Businesses?</h5>
                    </Col>
                    <CustomIconWithText
                        grid="row-cols-1 row-cols-lg-3 row-cols-sm-2"
                        theme="custom-icon-with-text02"
                        data={CustomIconWithTextData2}
                        animationDelay={0.3}
                        animation={fadeIn} />
                </Container>
            </section >

            {/* <m.section className="pricingtable-pricingpackages py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] bj" {...fadeIn}>
                <Container className='switch-tab'>
                    <Row className="justify-center">
                        <Col xl={7} lg={8} sm={7} className="text-center mb-14">
                            <h4 className="font-semibold -tracking-[1px] text-darkgray font-serif block heading-5">Pricing Plans for Businesses</h4>
                            <h5 className="font-serif font-medium ">Choose a plan that fits your hiring goals and verification needs.</h5>
                        </Col>
                    </Row>
                    <Tabs className="mb-[105px] md:mb-[50px] sm:mb-[20px]"
                        defaultActiveKey="monthly">
                        <Tab eventKey="monthly" title="MONTHLY">
                            <Row className="justify-center">
                                <PricingTable grid="row-cols-1 row-cols-lg-3 justify-center items-center" theme="pricing-table-style-01 col-12 col-lg-4 col-md-8" className="" data={pricingTable03MonthData} themeColor="dark" />
                            </Row>
                        </Tab>
                        <Tab eventKey="yearly" title="YEARLY">
                            <Row className="justify-center">
                                <PricingTable grid="row-cols-1 row-cols-lg-3 justify-center items-center" theme="pricing-table-style-01 col-12 col-lg-4 col-md-8" className="" data={pricingTable03YearData} themeColor="dark" />
                            </Row>
                        </Tab>

                    </Tabs>
                </Container>
            </m.section> */}



            <m.section className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] bj" {...fadeIn}>
                <Container>
                    <Row className="justify-center">
                        <Col xl={6} lg={7} className="text-center mb-[4.5rem] md:mb-12">

                            <h4 className="font-serif font-semibold text-darkgray">For customized pricing and packages contact us </h4>
                        </Col>
                        <ContactForm />
                    </Row>
                </Container>
            </m.section>



            <section className=" py-[130px] lg:py-[90px] md:py-[75px] sm:[50px]">
                <Container>
                    <Row className="justify-center">
                        <m.div className="col-xl-5 col-lg-6 col-sm-8 mb-20 text-center" {...fadeIn}>
                            {/* <span className="inline-block font-serif text-md uppercase mb-[20px] font-medium yellow-class">What people are saying</span> */}
                            <h3 className="w-full mb-[20px] font-semibold text-darkgray font-serif heading-5">What our valuable customer are saying about us?</h3>
                        </m.div>
                    </Row>
                    <Row className='sm:justify-center sm:flex'>
                        <Col md={12} sm={8}>
                            <Testimonials
                                grid="row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-sm-8 gap-y-10 justify-center"
                                theme='testimonials-style-03'
                                data={TestimonialsData03}
                                animation={fadeIn}
                            />
                        </Col>
                    </Row>
                </Container>
            </section>
            {/* Section End */}

            <hr />
            {/* Section Start */}
            <section className=" py-[120px] lg:py-[90px] md:py-[75px] ">
                <Container>
                    <Row className="justify-center">
                        <Col lg={11}>
                            <Clients grid="row-cols-2 row-cols-lg-6 row-cols-sm-3 md:gap-10 xs:gap-y-[50px] justify-between md:justify-center" theme="client-logo-style-05" data={ClientData} animation={fadeIn} />
                        </Col>
                    </Row>
                </Container>
            </section>
            <LetGo
                headingLines={["Start Hiring", "Smart Hiring.",]}
                subHeading=""
            />



            {/* Section End */}
            <FooterStyle theme="dark" className="bg-black text-[#828282] seo-agency-footer_06" />
        </div>
    )
}

export default Businesses
